/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './job-leters-docs.dto';
export * from './job-leters-docs-rest.service';
